import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createCallHistoryReportSlice = (set, get) => ({
    crmCallHistoryReport: {
        loading: false,
        data: []
    },
    postCrmCallHistoryReport: async (params) => {


        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmCallHistoryReport: { ...state.crmCallHistoryReport, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "post",
                baseURL: config.apiUrls(),
                url: `/v1/crm/call-history`,
                data: params.params,
                headers: { token },
            });

            params?.cb();
            params?.reset();
            params?.call();

            set(state => ({ crmCallHistoryReport: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmCallHistoryReport: { loading: false, data: [] } }));
        }
    }
});
